import DOMUtils from '../dom/DOMUtils';
import RuntimeUtils from '../system/RuntimeUtils';
if (RuntimeUtils.isBrowser()) {
    HTMLElement.prototype.clearValue = function (propertyName) {
        DOMUtils.clearValue(this, propertyName);
    };
    HTMLElement.prototype.ensureMiddleH = function (scrollableElem) {
        DOMUtils.ensureMiddleH(this, scrollableElem);
    };
    HTMLElement.prototype.ensureMiddleV = function (scrollableElem) {
        DOMUtils.ensureMiddleV(this, scrollableElem);
    };
    HTMLElement.prototype.ensureVisibleH = function (scrollableElem) {
        DOMUtils.ensureVisibleH(this, scrollableElem);
    };
    HTMLElement.prototype.ensureVisibleV = function (scrollableElem) {
        DOMUtils.ensureVisibleV(this, scrollableElem);
    };
    HTMLElement.prototype.getComputedNumericValue = function (propertyName) {
        return DOMUtils.getComputedNumericValue(this, propertyName);
    };
    HTMLElement.prototype.getComputedStyle = function () {
        return window.getComputedStyle(this);
    };
    HTMLElement.prototype.setNumericValue = function (propertyName, value, unit) {
        DOMUtils.setNumericValue(this, propertyName, value, unit);
    };
    HTMLElement.prototype.scrollToH = function (targetElement, offset) {
        DOMUtils.scrollToH(this, targetElement, offset);
    };
    HTMLElement.prototype.scrollToV = function (targetElement, offset) {
        DOMUtils.scrollToV(this, targetElement, offset);
    };
}
//# sourceMappingURL=HTMLElementExtensions.js.map